import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { boathouse, boathousePhotos } from '../data/boathouse';
const ease = [0.23, 1, 0.32, 1] as const;

// The exterior shot is already the Boathouse hero slide, so this section uses the others.
const [tikiBar, deck, diningRoom] = ['The tiki bar', 'Dining deck & dock', 'Dining room'].map(title => boathousePhotos.find(p => p.title === title)!);
export function BoathouseFeature() {
  return <section id="boathouse" className="bg-white py-24 px-6 md:px-10 scroll-mt-24" data-id="element-24" data-mp="fpvw6njm3cf8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-25" data-mp="aozpy3bsfe6n">
        {/* Imagery */}
        <Link to={boathouse.slug} className="lg:col-span-7 grid grid-cols-2 gap-4" aria-label="See the Boathouse renderings" data-id="element-26" data-mp="5talpmotp940">
          <div className="group col-span-2 overflow-hidden" data-id="element-27" data-mp="2qgnlbub5kync">
            <img src={tikiBar.src} alt={tikiBar.title} className="w-full h-64 md:h-[380px] object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-28" data-mp="39k8ibyqj3jpr" />
          </div>
          {[deck, diningRoom].map(photo => <div key={photo.src} className="group overflow-hidden" data-id="element-29" data-mp="34kvy7lr1kqqv">
              <img src={photo.src} alt={photo.title} className="w-full h-40 md:h-56 object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-30" data-mp="34j1bq304gqko" />
            </div>)}
        </Link>

        {/* Story */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.3,
        ease
      }} className="lg:col-span-5" data-id="element-31" data-mp="2gx4hm5ygxrjs">
          <p className="text-[#C5A55A] text-xs tracking-[0.3em] uppercase mb-5" data-id="element-32" data-mp="2bwgi0vw6c2dy">
            Upcoming development · {boathouse.status}
          </p>
          <h2 className="font-serif font-bold leading-tight text-black" data-id="element-33" data-mp="1stog8dsrwbo1">
            <span className="block text-4xl md:text-6xl" data-id="element-34" data-mp="1o03fwf3pj5lo">{boathouse.name}</span>
            <span className="block text-2xl md:text-3xl text-[#C5A55A] italic font-normal mt-2" data-id="element-35" data-mp="1j0z91v499jyi">
              {boathouse.subtitle}
            </span>
          </h2>
          <p className="flex items-center gap-2 text-gray-500 mt-6" data-id="element-36" data-mp="2bqfuu9xde2lr">
            <MapPin className="w-4 h-4 text-[#C5A55A] shrink-0" aria-hidden="true" data-id="element-37" data-mp="2bpoaxwd4xtbb" />
            {boathouse.location}
          </p>
          <p className="text-xl text-gray-800 font-light leading-relaxed mt-8" data-id="element-38" data-mp="21s9sxsbkcwgw">
            {boathouse.tagline}
          </p>

          <ul className="grid grid-cols-2 gap-x-6 border-t border-gray-200 mt-8" data-id="element-39" data-mp="1wtylfo8qqy1u">
            {boathouse.features.slice(0, 4).map(f => <li key={f} className="py-3 border-b border-gray-200 text-sm text-black" data-id="element-40" data-mp="qeegwsfyh3tw">
                {f}
              </li>)}
          </ul>

          <Link to={boathouse.slug} className="group mt-10 inline-flex items-center gap-2 bg-black hover:bg-[#C5A55A] text-white hover:text-black px-8 py-4 font-medium rounded-sm transition-colors duration-200" data-id="element-41" data-mp="2x2510m86p33a">
            Explore the Boathouse
            <ArrowRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-42" data-mp="3bpzwgadktlk2" />
          </Link>
        </motion.div>
      </div>
    </section>;
}